// displays the full date
export function date(value: string | Date) {
    if (!value) {
        return null;
    }
    return new Date(value).toLocaleDateString("en-US");
}
